import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import parseEvent from './helpers/parseEvent';
import { netEntParseEvent, netEntParseEventWeb } from './helpers/netEntParseEvent';
import store from '../../state/store';
import { addXp } from '../../state/slices/xp/xp';
import { addCoins, subtractCoins, setLastWin } from '../../state/actions/extras';
import { tooltipDetails, shouldShowTooltip } from '../../state/actions/tooltip';
import { clearOnboarding, setOnboardingFtueStep, setOnboardingHighlightedPosition } from '../../state/actions/currentOnboarding';
import { setLastTimeRatingSeen } from '../../state/actions/playerInfo';
import jsonParser, { Name as jsonParserName } from './helpers/jsonParser';
import kvpParser, { Name as kvpParserName } from './helpers/KeyValuePairParser';
import LevelUpInterface from '../LevelUpInterface';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Screens from '../../screens/index';
import ShowRateUs from '../../utils/ShowRateUs';
import Logger from '../../lib/analytics/logger';
import Utils from '../../utils/game';
import appUtils from '../../utils/';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import { TooltipTypes } from '../../utils/tooltipConstants';
import generalUtils from '../../utils';
/**
 * @class
 * @virtual
 * Base class for interacting with games. Implements common functionality and helpers.
 * This class should not be used directly. Instantiate a subclass according to the game provider.
 */

var GameInterface = /*#__PURE__*/function () {
  /**
   * GameInterface constructor
   * @param {Object} args
   * @param {import("../Constants").BetInfo} args.BetInfo
   * @param {Function} args.ExitFunc
   */
  function GameInterface(args) {
    var _this = this;

    _classCallCheck(this, GameInterface);

    this._dispatcher = null;

    this._exitFunc = function () {};

    this.messageHandle = function (message, provider) {
      var event;

      switch (provider) {
        case 'netent':
          if (appUtils.getPlatform() !== 'web') {
            event = netEntParseEvent(message, _this.parsers);
          } else {
            event = netEntParseEventWeb(message, _this.parsers);
          }

          break;

        default:
          event = parseEvent(message, _this.parsers);
          break;
      }

      if (event) {
        _this.receivedEvent(event);
      }
    };

    this.jsonParserEvent = function (event) {
      console.warn("Unhandled JSONParserEvent: ".concat(JSON.stringify(event)));
    };

    this.kvpParserEvent = function (event) {
      console.warn("Unhandled kvpParserEvent: ".concat(JSON.stringify(event)));
    };

    this.sendEvent = function (message) {
      if (_this._dispatcher != null) {
        _this._dispatcher(message);
      }
    };

    this.sendAnalyticEvent = function () {
      var _store$getState$gameI = store.getState().gameInfo,
          gameId = _store$getState$gameI.gameId,
          gameType = _store$getState$gameI.gameType;
      var trigger = Logger.getActionTrigger();
      var unlockLevel = Utils.getUnlockLevel(gameId, gameType);
      var isFeatured = Utils.isFeaturedGame(gameId) ? 'true' : 'false';
      if (!unlockLevel) return;
      var eventPayload = {
        trigger: trigger,
        game_type: gameType,
        is_featured: isFeatured,
        unlock_level: unlockLevel.UNLOCK_LEVEL
      };

      if (!_this.hasSentGameLoadedEvent) {
        Logger.sendEvent(EVENT_TYPES.GAME_LOADED, eventPayload);
        _this.hasSentGameLoadedEvent = true;
      }
    };

    this.sendErrorCreatedEvent = function (errorDescription) {
      var _store$getState$gameI2 = store.getState().gameInfo,
          gameId = _store$getState$gameI2.gameId,
          gameType = _store$getState$gameI2.gameType;
      var eventPayload = {
        game_id: gameId,
        game_provider: gameType,
        description: errorDescription,
        code: 1
      };
      Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
    };

    this.dispatcherAttached = function () {};

    this.getBetInfo = function () {};

    this.AddLocalXP = function (amount) {
      var state = store.getState();
      var currentXp = state.xpInfo.xp;
      var xpRequired = state.xpInfo.xpRequired;
      console.log("Adding ".concat(amount, " XP. New XP: ").concat(currentXp + amount, "/").concat(xpRequired));
      store.dispatch(addXp(amount)); // If this was enough xp to level up

      if (currentXp + amount >= xpRequired) {
        // Request server to try level up
        LevelUpInterface.tryLevelUp();
      }
    };

    this.AddSpinXP = function (bet) {
      var state = store.getState();
      var coinAmount = parseInt(state.coin.value);

      if (coinAmount >= parseInt(bet)) {
        _this.AddLocalXP(_this.GetSpinXP(bet));
      }
    };

    this.GetSpinXP = function (bet) {
      var state = store.getState();
      var baseSpinXp = state.xpInfo.xpPerSpin;
      var multiplier = state.xpInfo.xpBetMultiplier;
      var wagerBetMultiplier = 1; // if (betData.bonusXP && _lastPlayerBet >= betData.bonusXPThreshold) {
      //   wagerBetMultiplier = parseFloat(betData.bonusXP.multiplier)
      // }

      return (baseSpinXp + multiplier * bet) * wagerBetMultiplier;
    };

    this.CreditCoins = function (amount) {
      store.dispatch(addCoins(amount));
    };

    this.DebitCoins = function (amount) {
      var coinBalance = store.getState().coin.value;

      if (parseInt(coinBalance) >= parseInt(amount)) {
        store.dispatch(subtractCoins(amount));
      }
    };

    this.showOutOfCoinsScreen = function () {
      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.OutOfCoin));
      var outOfCoins = store.getState().consumables.outOfCoins;
      var eventPayload = {
        product_id: outOfCoins.CURRENCY_ITEM_ID,
        amount: outOfCoins.PRICE
      };
      Logger.sendEvent(EVENT_TYPES.OOC_POP_UP_SHOWED, eventPayload);
    };

    this.GetLastWin = function () {
      return store.getState().lastWin.value;
    };

    this.SetLastWin = function (amount) {
      store.dispatch(setLastWin(amount));
    };

    this.showRateUsScreen = function () {
      var lastTimeRatePopup = store.getState().playerInfo.lastTimeRated;
      var newTime = new Date();
      var timeLimit = 86400000; // 24 * 60 * 60 * 1000 = 24 hours in ms;

      var timeDiff = !lastTimeRatePopup ? 0 : newTime - new Date(lastTimeRatePopup);

      if (timeDiff > timeLimit || timeDiff === 0) {
        ShowRateUs();
        store.dispatch(setLastTimeRatingSeen(newTime));
      }
    };

    this.showFtuePopUpAnimation = function () {
      var style = null;

      if (generalUtils.getPlatform() === 'web') {
        var currentStopElm = document.getElementsByClassName('LevelBar');

        if (currentStopElm) {
          currentStopElm = currentStopElm[0];
          style = currentStopElm.getBoundingClientRect();
        }
      }

      var _tooltipDetails = generalUtils.getPlatform() === 'web' ? {
        title: 'LEVEL UP TO GET',
        source: {},
        ibw: {},
        iconType: null,
        animationState: 'AnimationSlideFromTop',
        containerStyle: {
          height: 160,
          top: '-3rem'
        },
        style: {
          left: style ? style.x + 40 : '15%'
        },
        arrowStyle: {
          left: '38%',
          zIndex: 100
        },
        children: null,
        showDivider: true,
        popUpType: TooltipTypes.FTUE
      } : {
        title: 'LEVEL UP TO GET',
        source: {},
        ibw: {},
        iconType: null,
        animationState: 'in',
        containerStyle: {
          width: _this._RFValue(210),
          height: _this._deviceInfo.isTablet() ? _this._RFValue(82) : _this._RFValue(100),
          top: _this._deviceInfo.isTablet() ? '10%' : '17%',
          left: _this._deviceInfo.isTablet() ? '6%' : '10%'
        },
        children: null,
        showDivider: true,
        popUpType: TooltipTypes.FTUE
      };

      store.dispatch(tooltipDetails(_tooltipDetails));
      store.dispatch(shouldShowTooltip(true));
      setTimeout(function () {
        _tooltipDetails.animationState = generalUtils.getPlatform() === 'web' ? 'AnimationSlideToTop' : 'out';
        store.dispatch(tooltipDetails(_tooltipDetails));
        setTimeout(function () {
          store.dispatch(shouldShowTooltip(false));
        }, 800);
      }, 5000);
    };

    this.checkFtueStep = function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var ftueStep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var message = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      if (!state) {
        store.dispatch(clearOnboarding());

        _this.showFtuePopUpAnimation();

        return;
      }

      store.dispatch(setOnboardingFtueStep(ftueStep));
      if (position) store.dispatch(setOnboardingHighlightedPosition(position, message));
    };

    this._deviceInfo = args.deviceInfo;
    this._RFValue = args.RFValue;
    this._dimension = args.dimension;
    this._exitFunc = args.ExitFunc; // console.log(`GameInterface Loaded: ${this.constructor.name}`);

    this._betInfo = args.BetInfo;
    this._betInfoSent = false;
    this._gameReady = args.GameReady;
    this._outOfCoins = args.OutOfCoins;
    this.showSpinEffect = false;
    this.timer = null;
    this.gameType = args.gameType;
    this.embedData = args.embedData;
    var storeState = store.getState();
    this.soundSettings = {
      soundEffects: storeState.playerInfo.soundEffects,
      music: storeState.playerInfo.music
    };
  }

  _createClass(GameInterface, [{
    key: "receivedEvent",
    value:
    /**
     * @virtual
     * @param {import("./helpers/parseEvent").ParsedEvent} event
     */
    function receivedEvent(event) {
      // console.log(event);
      switch (event._from) {
        case jsonParserName:
          {
            this.jsonParserEvent(event.payload);
            break;
          }

        case kvpParserName:
          {
            this.kvpParserEvent(event);
            break;
          }

        default:
          break;
      }
    }
    /**
     * Generic JSON Event Handler
     * @param {import("./helpers/parseEvent").ParsedEvent} event
     */

  }, {
    key: "sendKeyValuePair",
    value:
    /**
     * Convenience method to send a kvp via sendEvent
     * @param {String} key
     * @param {String} value
     */
    function sendKeyValuePair(key) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var msg = "".concat(key.toString().toUpperCase(), ":").concat(value !== null ? value.toString().toUpperCase() : '');
      this.sendEvent(msg);
    }
    /**
     * Set this dispatcher that will post the message back to the game.
     * If already set, this is a no-op.
     */

  }, {
    key: "dispatcher",
    get: function get() {
      return this._dispatcher;
    },
    set: function set(value) {
      if (this._dispatcher === null) {
        this._dispatcher = value;
        this.dispatcherAttached();
      }
    }
    /** Callback that child classes can use post dispatcher attachment */

  }, {
    key: "exitFunc",
    get: function get() {
      return this._exitFunc;
    }
    /**
     * @virtual
     * Define which parsers the wrapper should use.
     */

  }, {
    key: "parsers",
    get: function get() {
      return [jsonParser, kvpParser];
    }
    /**
     * @virtual
     * Which quest actions can this game interface support?
     * Used for determining best quest to show on tracker.
     */

  }, {
    key: "trackableActions",
    get: function get() {
      return [];
    }
  }]);

  return GameInterface;
}();

export default GameInterface;